// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

// const OurTeam = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   const teamMembers = [
//     {
//       id: 1,
//       name: 'Adarsh Singh',
//       role: 'Director',
//       image: '/images/team1.png',
//       description: 'Leading Docmize with vision and strategy for healthcare digital marketing.',
//       position: 'object-center'
//     },
//     {
//       id: 2,
//       name: 'Vishali',
//       role: 'Director',
//       image: '/images/team2.png',
//       description: 'Driving innovation and excellence across all our marketing projects.',
//       position: 'object-center'
//     },
//     {
//       id: 3,
//       name: 'Yash Sharma',
//       role: 'Co-Founder',
//       image: '/images/team3.png',
//       description: 'Shaping the future of healthcare digital transformation.',
//       position: 'object-center'
//     },
//     {
//       id: 6,
//       name: 'Aditya Singh',
//       role: 'Manager',
//       image: '/images/team5.png',
//       description: 'Managing day-to-day operations and ensuring seamless delivery across all client projects.',
//       position: 'object-top'
//     },
//     {
//       id: 4,
//       name: 'Sunidhi Sharma',
//       role: 'MERN Developer',
//       image: '/images/team7.png',
//       description: 'Building powerful websites and apps for healthcare practices.',
//       position: 'object-center'
//     },
//     {
//       id: 5,
//       name: 'Santosh Kumar',
//       role: 'SEO & GEO Manager',
//       image: '/images/team4.png',
//       description: 'Making sure your practice shows up first on Google searches.',
//       position: 'object-center'
//     },
//     {
//       id: 8,
//       name: 'Vaibhav',
//       role: 'Senior Sales Executive',
//       image: '/images/team8.png',
//       description: 'Connecting healthcare providers with smart digital solutions.',
//       position: 'object-center'
//     },
//   ];

//   return (
//     <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
//       <Navbar />

//       {/* HERO SECTION */}
//       <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{ backgroundImage: `url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80')` }}
//         />
//         <div className="absolute inset-0 bg-[#19354a]/90" />
        
//         <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl mx-auto">
//           <motion.h1 
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6"
//           >
//             Our Team
//           </motion.h1>

//           <motion.div 
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//             className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
//           >
//             <Link to="/" className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base">
//               Home
//             </Link>
//             <span className="text-white text-xl sm:text-2xl">|</span>
//             <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
//               Our Team
//             </span>
//           </motion.div>
//         </div>
//       </section>

//       {/* MAIN CONTENT */}
//       <section className="py-12 sm:py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
//           {/* Header */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             className="text-center mb-12"
//           >
//             <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-4 uppercase tracking-wide">
//               Meet The Experts Behind Your Success
//             </h2>
//             <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-4xl mx-auto">
//               Our dedicated team of healthcare marketing professionals brings expertise, passion, and innovation to every project. Get to know the people committed to your practice's growth.
//             </p>
//           </motion.div>

//           {/* Team Grid */}
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {teamMembers.map((member, index) => (
//               <motion.div
//                 key={member.id}
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className="relative group cursor-pointer overflow-hidden rounded-lg shadow-lg h-96"
//                 onMouseEnter={() => setHoveredCard(member.id)}
//                 onMouseLeave={() => setHoveredCard(null)}
//               >
//                 <div className="relative h-full overflow-hidden">
//                   <img 
//                     src={member.image} 
//                     alt={member.name}
//                     className={`w-full h-full object-cover ${member.position} transition-transform duration-500 group-hover:scale-110`}
//                   />
                  
//                   <div 
//                     className="absolute inset-0 bg-[#19354a] transition-all duration-500"
//                     style={{
//                       clipPath: hoveredCard === member.id 
//                         ? 'polygon(100% 75%, 100% 100%, 0 100%, 0 50%)' 
//                         : 'polygon(100% 75%, 100% 100%, 0 100%, 0 85%)'
//                     }}
//                   >
//                     <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
//                       <h3 className={`text-lg sm:text-xl font-bold transition-all duration-500 leading-tight ${
//                         hoveredCard === member.id ? 'text-left mb-2' : 'text-center'
//                       }`}>
//                         {member.name}
//                       </h3>
                      
//                       <div className={`transition-all duration-500 ${
//                         hoveredCard === member.id ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0'
//                       } overflow-hidden`}>
//                         <h4 className="text-base font-semibold mb-2 uppercase tracking-wide">
//                           {member.role}
//                         </h4>
//                         <p className="text-sm text-white/90 leading-relaxed">
//                           {member.description}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           {/* Bottom CTA */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//             className="mt-16 text-center bg-gradient-to-r from-[#19354a] to-[#39a5d3] rounded-2xl p-8 sm:p-12"
//           >
//             <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
//               Ready to Work with Our Expert Team?
//             </h3>
//             <p className="text-white/90 text-base sm:text-lg mb-8 max-w-2xl mx-auto">
//               Let our experienced professionals help your healthcare practice grow with proven Growth Ecosystem strategies.
//             </p>
//             <Link
//               to="/contact"
//               className="inline-block px-8 py-4 bg-white text-[#19354a] rounded-lg font-bold text-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
//             >
//               Get Started Today
//             </Link>
//           </motion.div>

//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// }; 

// export default OurTeam;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const OurTeam = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const teamMembers = [
    {
      id: 1,
      name: 'Adarsh Singh',
      role: 'Director',
      image: '/images/team1.png',
      description: 'Leading Docmize with vision and strategy for healthcare digital marketing.',
      position: 'object-center'
    },
    {
      id: 2,
      name: 'Vishali',
      role: 'Director',
      image: '/images/team2.png',
      description: 'Driving innovation and excellence across all our marketing projects.',
      position: 'object-center'
    },
    {
      id: 4,
      name: 'Aditya Singh',
      role: 'HR Manager',
      image: '/images/team5.png',
      description: 'Managing human resources and ensuring a positive work environment across all teams.',
      position: 'object-top'
    },
    {
      id: 8,
      name: 'Krishi Jain',
      role: 'Sales Manager',
      image: '/images/team9.png',
      description: 'Building lasting partnerships with healthcare practices and driving business growth.',
      position: 'object-top'
    },
    {
      id: 9,
      name: 'Santosh Kumar',
      role: 'GMB & SEO Manager',
      image: '/images/team10.png',
      description: 'Boosting local visibility and search rankings through Google Business Profile and SEO strategies.',
      position: 'object-top'
    },
    {
      id: 5,
      name: 'Sunidhi Sharma',
      role: 'MERN Developer',
      image: '/images/team7.png',
      description: 'Building powerful websites and apps for healthcare practices.',
      position: 'object-center'
    },
    {
      id: 6,
      name: 'Madhumita Joshi',
      role: 'SEO Intern',
      image: '/images/team4.png',
      description: 'Helping healthcare practices improve their online visibility and search rankings.',
      position: 'object-center'
    },
    {
      id: 7,
      name: 'Tripti Behra',
      role: 'Graphic Designer',
      image: '/images/team8.png',
      description: 'Creating compelling visual designs that bring healthcare brands to life.',
      position: 'object-center'
    },
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80')` }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl mx-auto">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6"
          >
            Our Team
          </motion.h1>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link to="/" className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base">
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Our Team
            </span>
          </motion.div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-4 uppercase tracking-wide">
              Meet The Experts Behind Your Success
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-4xl mx-auto">
              Our dedicated team of healthcare marketing professionals brings expertise, passion, and innovation to every project. Get to know the people committed to your practice's growth.
            </p>
          </motion.div>

          {/* Team Grid — same design for both mobile and desktop */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative group cursor-pointer overflow-hidden rounded-lg shadow-lg h-96"
                onMouseEnter={() => setHoveredCard(member.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="relative h-full overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className={`w-full h-full object-cover ${member.position} transition-transform duration-500 group-hover:scale-110`}
                  />
                  
                  <div 
                    className="absolute inset-0 bg-[#19354a] transition-all duration-500"
                    style={{
                      clipPath: hoveredCard === member.id 
                        ? 'polygon(100% 75%, 100% 100%, 0 100%, 0 50%)' 
                        : 'polygon(100% 75%, 100% 100%, 0 100%, 0 85%)'
                    }}
                  >
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                      <h3 className={`text-lg sm:text-xl font-bold transition-all duration-500 leading-tight ${
                        hoveredCard === member.id ? 'text-left mb-2' : 'text-center'
                      }`}>
                        {member.name}
                      </h3>
                      
                      <div className={`transition-all duration-500 ${
                        hoveredCard === member.id ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0'
                      } overflow-hidden`}>
                        <h4 className="text-base font-semibold mb-2 uppercase tracking-wide">
                          {member.role}
                        </h4>
                        <p className="text-sm text-white/90 leading-relaxed">
                          {member.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Bottom CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mt-16 text-center bg-gradient-to-r from-[#19354a] to-[#39a5d3] rounded-2xl p-8 sm:p-12"
          >
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
              Ready to Work with Our Expert Team?
            </h3>
            <p className="text-white/90 text-base sm:text-lg mb-8 max-w-2xl mx-auto">
              Let our experienced professionals help your healthcare practice grow with proven Growth Ecosystem strategies.
            </p>
            <Link
              to="/contact"
              className="inline-block px-8 py-4 bg-white text-[#19354a] rounded-lg font-bold text-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Get Started Today
            </Link>
          </motion.div>

        </div>
      </section>

      <Footer />
    </div>
  );
}; 

export default OurTeam;